export default function Author(props) {
    return (
        <div className="author">
            <div className="author__img__container">
                <img src={props.src} className="author__img" alt="Author Image" />
            </div>
            <span className="author__name">{props.name}</span>
        </div>
    )
}